import { utils } from "./GeoProjects.js";

export default class GeoProjectsModule {
    constructor(){
        this._fieldConfiguration = [
            {
                reference: 'repositories',
                input_type: 'dropdown',
                tag_values: [],
                label:'Repository',
                pre_select: []
            },
            {
                reference: 'project_name',
                input_type: 'text',
                values: [],
                label:'Title',
                pre_select: []
            }
        ];
        this._firstLoad = false;
        this._currentPage = 1;
        this._projectsFilters = {}
        this._projectsList = [];
        this._currentTotalProjects = 0;
        this._controllers = [];
        this._timeOutFunction = null;
        this._projectsError = "";
        this._spinnerContainer = 'swlri-geo-projects-results-container';
        // read field configuration
    }

    get fieldConfiguration(){
        return this._fieldConfiguration;
    }

    get projectsError(){
        return this._projectsError;
    }

    get currentPage(){
        return this._currentPage;
    }

    set currentPage(val){
        this._currentPage = val;
        return this.getProjectsList();
    }

    set projectsFilters(val){
        this._projectsFilters = {...val};
        this._currentPage = 1;
        return this.getProjectsList();
    }

    getProjectsList(){
        clearTimeout(this._timeOutFunction);
        this._timeOutFunction = setTimeout(()=>{
            utils.freezeInterface(true,this._spinnerContainer);
            let repositories = {};
            this._getProjectsList().then((res)=>{

                if(res.success && res?.data?.projects && Array.isArray(res.data.projects) && res?.data?.repositories){
                    this._projectsList = [...res.data.projects];
                    repositories = {...res.data.repositories};
                    this._currentTotalProjects = res.data.totalCount;
                    this._projectsError = "";
                } else {
                    this._projectsError = res.data[0]?.message || 'Cannot load project list';
                    this._projectsList = [];
                    repositories = {};
                    this._currentTotalProjects = 0;
                }
            }).catch((err)=>{
                if(!err.name == 'AbortError'){
                    this._projectsError = 'Cannot load project list';
                    this._projectsList = [];
                    repositories = {};
                    this._currentTotalProjects = 0;
                    setTimeout(()=>{
                        utils.freezeInterface(false,this._spinnerContainer)
                    },300)
                }
            }).finally(()=>{
                this._timeOutFunction = null;
                let onAbort = this._controllers.filter((c)=>{
                    return c.signal.aborted
                })
                setTimeout(()=>{
                    if(onAbort.length == 0){
                        utils.freezeInterface(false,this._spinnerContainer)
                    }
                    this._initFieldConfiguration(repositories);

                    var customEv = new CustomEvent("swlri-geo-projects-list-changed")
                    window.dispatchEvent(customEv);
                }, 300)

            })
        },300)

    }

    async _getProjectsList(){
        if(this._controllers.length){
            this._controllers.forEach((cont)=>{
                cont.abort();
            })
        }

        const control = new AbortController();
        const signal = control.signal;
        this._controllers.push(control)

        let formData = new FormData();
        formData.append("pnum",this._currentPage);
        Object.keys(this._projectsFilters).forEach((k)=>{
            formData.append("filters["+k+"]",this._projectsFilters[k]);
        })

        const response = await fetch("/wp-admin/admin-ajax.php?"+new URLSearchParams({action: 'lizmap_projects'}), {
            method: "POST",
            body:formData,
            signal:signal
        })
        this._controllers = [];
        if(!response.ok){
            const resp = response.statusText;
            throw new Error(resp);
        } else { 
            const dataJson = await response.json();
            return dataJson;
        }
    }

    _initFieldConfiguration(repositories){
        if(!this._firstLoad){
            this._firstLoad = true;
            let repoKey = Object.keys(repositories);
            const repoObj = this._fieldConfiguration.filter((f)=> f.reference == 'repositories')[0]
            repoKey.forEach((k)=>{
                repoObj.tag_values.push({id:repositories[k].repo_id, value: repositories[k].label})
            })

            var customEv = new CustomEvent("swlri-geo-projects-loaded")
            window.dispatchEvent(customEv);
        }
    }

}